import React from 'react';
import { Link } from 'react-router-dom';

const PageTitle = ({ title }) => {
  return (
    <section
      className="page-title-section bg-img cover-background left-overlay-dark" data-overlay-dark="8"
      style={{ backgroundImage: 'url(/img/bg/page-title.jpg)' }}
    >
      <div className="container lg-container">
        <div className="row">
          <div className="col-md-12">
            <h1>{title}</h1>
          </div>
          <div className="col-md-12">
            <ul className="ps-0">
              <li><Link to="/">Home</Link></li>
              <li><a href="#!">{title}</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="d-inline-block p-3 rounded-circle bg-primary position-absolute z-index-1 top-35 right-20 ani-top-bottom"></div>
      <div className="d-inline-block p-2 rounded-circle bg-secondary position-absolute z-index-1 top-25 left-10 ani-top-bottom"></div>
      <div className="d-inline-block bg-white p-3 ani-zoomin rounded-circle position-absolute bottom-5 left-10 opacity1 z-index-1"></div>
    </section>

    
  );
};

export default PageTitle;
